import { useEffect, useState } from 'react';

const useWindowHeight = (): { windowHeight: number | undefined; isRendered: boolean } => {
    const [windowHeight, setWindowHeight] = useState<number>();
    const [isRendered, setIsRendered] = useState(false);

    useEffect(() => {
        const { visualViewport } = window as any;
        const setHeight = (): void => {
            setWindowHeight(window?.innerHeight);
        };

        if (window) {
            setHeight();

            window.addEventListener('resize', setHeight);
        }

        setIsRendered(true);

        return () => window.removeEventListener('resize', setHeight);
    }, []);

    return { windowHeight, isRendered };
};

export default useWindowHeight;
